var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.8197 30.3195C66.6594 29.4871 67.793 29.0187 68.9753 29.0154C70.1577 29.0121 71.2938 29.4743 72.1381 30.3021C72.9823 31.1298 73.4669 32.2565 73.4871 33.4387C73.5072 34.6209 73.0613 35.7635 72.2457 36.6195L48.2937 66.5595C47.8821 67.0029 47.3852 67.3587 46.8329 67.6057C46.2806 67.8527 45.6842 67.9857 45.0792 67.9969C44.4743 68.0081 43.8733 67.8972 43.3123 67.6709C42.7512 67.4445 42.2415 67.1073 41.8137 66.6795L25.9437 50.8035C25.5016 50.3915 25.147 49.8947 24.901 49.3427C24.6551 48.7907 24.5228 48.1948 24.5122 47.5906C24.5015 46.9864 24.6127 46.3862 24.839 45.8259C25.0653 45.2656 25.4022 44.7566 25.8295 44.3293C26.2568 43.9019 26.7658 43.5651 27.3261 43.3387C27.8865 43.1124 28.4866 43.0013 29.0909 43.0119C29.6951 43.0226 30.291 43.1548 30.843 43.4008C31.395 43.6468 31.8918 44.0014 32.3037 44.4435L44.8677 57.0015L65.7057 30.4515C65.7429 30.405 65.783 30.3609 65.8257 30.3195H65.8197Z",
    fill: "#00AF54"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 1.3,
    width: 94.4,
    height: 94.4,
    rx: 47.2,
    stroke: "#00AF54",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquare);
export default __webpack_public_path__ + "static/media/check-square.5cf474986741e6027a5c955a0be5afa8.svg";
export { ForwardRef as ReactComponent };